<!--TYPE DE CHAMP-->
<div class="form-group">

  @if (field.type!='hidden' && field.label.length > 0 && field.controlType !== 'checkbox') {
    <label [for]="field.key" class="genlabel no-overflow"
           [style.max-width.px]="250"
           [style.min-width.px]="250"
           class="font-10"
           [title]="getTooltip(field)">
      <span [style.width.px]="6">
        @if (field.required) {<span class="danger-color">*</span>}
        @else {&nbsp;}
      </span>{{field.label | uppercase}}
    </label>
  }

  @if (field.type!='hidden') {
    <div>
      @switch (field.controlType) {
        @case('checkbox') {
          <ng-container *ngTemplateOutlet="tplCheckbox;context:{field:field,form:form}"></ng-container>
        }
        @case('currency') {
          <ng-container *ngTemplateOutlet="tplCurrency;context:{field:field,form:form}"></ng-container>
        }
        @case('dropdown') {
          <ng-container *ngTemplateOutlet="tplDropdown;context:{field:field,form:form}"></ng-container>
        }
        @case('table') {
          <ng-container *ngTemplateOutlet="tplTable;context:{field:field,form:form}"></ng-container>
        }
        @case('tree') {
          <ng-container *ngTemplateOutlet="tplTree;context:{field:field,form:form}"></ng-container>
        }
        @case('textbox') {
          <ng-container *ngTemplateOutlet="tplTextbox;context:{field:field,form:form}"></ng-container>
        }
        @case('textarea') {
          <ng-container *ngTemplateOutlet="tplTextarea;context:{field:field,form:form}"></ng-container>
        }
        @case('selectbutton') {
          <ng-container *ngTemplateOutlet="tplSelectButton;context:{field:field,form:form}"></ng-container>
        }
        @case('primengeditor') {
          <ng-container *ngTemplateOutlet="tplPrimengEditor;context:{field:field,form:form}"></ng-container>
        }
        @case('calendar') {
          <ng-container *ngTemplateOutlet="tplCalendar;context:{field:field,form:form}"></ng-container>
        }
        @case('file') {
          <ng-container *ngTemplateOutlet="tplFile;context:{field:field,form:form}"></ng-container>
        }
      }
      <yo-dynamic-form-field-error-bs [form]="form" [field]="field"></yo-dynamic-form-field-error-bs>

      <!-- Pour d'éventuels messages à l'utilisateur -->
      <!-- cf. ProduitDeclinaisonService.changeUniteDeMesure -->
      <yo-dynamic-form-field-message-bs [form]="form" [field]="field"></yo-dynamic-form-field-message-bs>
    </div>
  }
</div>

<!--TEMPLATE CALENDAR-->
<ng-template #tplCalendar let-field="field" let-form="form">

  <div [formGroup]="form">
    <p-calendar formControlName="{{field.key}}"
                firstDayOfWeek="1"
                [style]="{'width':field.width+'px'}"
                [locale]="localeFr"
                [dateFormat]="field.dateFormat"
                [readonlyInput]="true"
                [showTime]="field.showTime"
                [disabled]="field.readonly"
                [showWeek]="true">
    </p-calendar>
  </div>

</ng-template>


<!--TEMPLATE CHECKBOX-->
<ng-template #tplCheckbox let-field="field" let-form="form">

  <div [formGroup]="form" class="d-flex align-items-center">
    <p-checkbox [formControl]="form.controls[field.key]"
                [disabled]="field.readonly"
                [id]="field.key"
                [label]="field.label | uppercase"
                binary="true"
                (onChange)="field.linkedFieldFn && field.linkedFieldFn($event.checked, form, fields, null)">
    </p-checkbox>
    @if (field.required) {
      <span class="danger-color ml-1">*</span>
    }
  </div>

</ng-template>

<!--TEMPLATE CURRENCY-->
<ng-template #tplCurrency let-field="field" let-form="form">

  <div class="input-group input-group-sm " [formGroup]="form">
    <input type="text" [style.max-width.px]="field.width" style="text-align: right;"
           class="form-control form-control-sm "
           id="{{field.key}}"
           placeholder=""
           (change)="changeInput($event)"
           pKeyFilter="pnum"
           formControlName="{{field.key}}" [readonly]="field.readonly">
    <div class="input-group-append ">
      @if (field.suffix) {
        <span class="input-group-text"
              [innerHTML]="dsSvc.bypassSecurityTrustHtml(field.suffix)"></span>
      } @else {
        <span class="input-group-text">€</span>
      }
      <ng-container *ngTemplateOutlet="tplIsFieldOk;context:{field:field,form:form}"></ng-container>
    </div>
  </div>

</ng-template>

<!--TEMPLATE TABLE-->
<ng-template #tplTable let-field="field" let-form="form">

  @if (field.readonly) {
    <dx-data-grid
      [allowColumnResizing]="true"
      [dataSource]="field.value"
      keyExpr="id"
      [height]="field.tableHeight"
      [showBorders]="false"
      [title]="field.help">
      @for(col of field.cols; track col) {
        <dxi-column [dataField]="col.field" [caption]="col.header"></dxi-column>
      }
    </dx-data-grid>
  } @else {
    <dx-data-grid
      [allowColumnResizing]="true"
      [dataSource]="field.options"
      keyExpr="id"
      [height]="field.tableHeight"
      [hoverStateEnabled]="true"
      [selectedRowKeys]="selectedRowKeys"
      [showBorders]="true"
      (onFocusedRowChanged)="onSelectRowSingle($event)"
      [focusedRowEnabled]="true"
      [(focusedRowKey)]="selectedRowKeys"
    >
      <dxo-filter-row
        [visible]="true"
        [applyFilter]="[]"></dxo-filter-row>
      <dxo-paging [pageSize]="900"></dxo-paging>

      <dxo-selection mode="single"></dxo-selection>

      @for(col of field.cols; track col) {
        <dxi-column [dataField]="col.field" [caption]="col.header"></dxi-column>
      }

    </dx-data-grid>
  }
</ng-template>

<!--TEMPLATE TREE-->
<ng-template #tplTree let-field="field" let-form="form">

  @if (field.readonly) {
    <label class="badge badge-secondary text-white p-2 mg-b-3 font-12">{{getTreeLabel(field)}}</label>
  } @else {
    <div class="cursor">
      @if(utils.isNullOrEmpty(field.value)) {
        <label class="badge badge-secondary text-white p-2 mg-b-3 font-12"
               (click)="showTree()">Sélectionner...</label>
      } @else {
        <label class="badge badge-secondary text-white p-2 mg-b-3 font-12"
               (click)="showTree()">{{getTreeLabel(field)}}</label>
      }
    </div>

    @if (displayTree) {
      <dx-tree-list
        id="parent-grid"
        [dataSource]="field.options"
        [showColumnHeaders]="false"
        [rootValue]="null"
        keyExpr="id"
        [width]="380"
        [height]="field.tableHeight"
        parentIdExpr="parent.id"
        [showRowLines]="true"
        [showBorders]="true"
        [columnAutoWidth]="true"
        [focusedRowEnabled]="true"
        [(focusedRowKey)]="selectedRowKeys"
        (onFocusedRowChanged)="onSelectRowSingle($event)"
        [selectedRowKeys]="[field?.value?.id]"
        [expandedRowKeys]="this.expandedRowKeys">

        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-selection mode="single"></dxo-selection>

        @for (col of field.cols; track col) {
          <dxi-column [dataField]="col.field" [caption]="col.header"></dxi-column>
        }
      </dx-tree-list>
    }
  }
</ng-template>

<!--TEMPLATE DROPDOWN-->
<ng-template #tplDropdown let-field="field" let-form="form">

  <div class="input-group input-group-sm " [formGroup]="form">

    @switch (field.key) {
      @case ('couleur') {
        <ng-container *ngTemplateOutlet="tplColor;context:{field:field,form:form}"></ng-container>
      }
      @default {
        @switch (field.type) {
          @case ('multiple') {
            <!--[style]="{'max-width':field.width+'px'}"-->
            <p-multiSelect
              formControlName="{{field.key}}"
              appendTo="body"
              [options]="field.options"
              (onChange)="changeMultiSelect($event)"
              optionLabel="{{field.optionLabel}}"
              selectedItemsLabel="{0} {{field.label.toLowerCase()}}"
              [defaultLabel]="field.label+'...'"
              [maxSelectedLabels]="4"
              [disabled]="field.readonly"
            ></p-multiSelect>
          }
          @case ('externalRef') {
            <p-dropdown [style]="{'max-width':field.width+'px'}"
                        filter="true"
                        (onChange)="changeExternalRef($event)"
                        showClear="true"
                        placeholder="sélection..."
                        appendTo="body"
                        [options]="field.options"
                        [disabled]="field.readonly"
                        [formControlName]="field.key"
                        optionLabel="{{field.optionLabel}}"></p-dropdown>
          }
          @case ('multipleListBox') {
            <p-listbox [options]="field.options"
                       multiple="true"
                       [style]="{'max-width':field.width+'px','min-width':field.width+'px'}"
                       (onChange)="changeDropdown($event)"
                       [disabled]="field.readonly"
                       checkbox="true"
                       filter="true"
                       [formControlName]="field.key"
                       optionLabel="{{field.optionLabel}}">
            </p-listbox>
          }
          @case ('multipleListBoxSiteAndValue') {
            <p-listbox [options]="field.options"
                       multiple="true"
                       [style]="{'max-width':field.width+'px','min-width':field.width+'px'}"
                       (onChange)="changeDropdown($event)"
                       [disabled]="field.readonly"
                       checkbox="true"
                       filter="true"
                       [formControlName]="field.key"
                       optionLabel="{{field.optionLabel}}">
              <ng-template let-item pTemplate="item">

                <yo-site [siteLibelleTooltip]="item.site.libelle"
                         [siteId]="item.site.id">
                </yo-site>
                {{item.libelle | uppercase}}
              </ng-template>

            </p-listbox>
          }
          @case ('singleListBox') {
            <p-listbox [options]="field.options"
                       [style]="{'max-width':field.width+'px','min-width':field.width+'px'}"
                       (onChange)="changeDropdown($event)"
                       [disabled]="field.readonly"
                       checkbox="false"
                       filter="true"
                       dataKey="id"
                       [formControlName]="field.key"
                       optionLabel="{{field.optionLabel}}">
            </p-listbox>
          }
          @default {
            <!--            <pre>{{field.dto.contratMenuConvive__contrainteAlimList | json}}</pre>-->
            <p-dropdown [style]="{'max-width':field.width+'px'}"
                        filter="true"
                        showClear="true"
                        placeholder="sélection..."
                        appendTo="body"
                        (onChange)="changeDropdown($event)"
                        [options]="field.options"
                        [disabled]="field.readonly"
                        [formControlName]="field.key"
                        optionLabel="{{field.optionLabel}}"></p-dropdown>
          }
        }
      }
    }

    <div class="input-group-append">
      <ng-container *ngTemplateOutlet="tplIsFieldOk;context:{field:field,form:form}"></ng-container>
    </div>

  </div>

</ng-template>


<!--TEMPLATE TEXTBOX-->
<ng-template #tplTextbox let-field="field" let-form="form">

  <div [formGroup]="form">

    @switch (field.key) {
      @case ('site') {
        @if (field.type!=='hidden') {
          <yo-site [siteId]="field?.value?.id" [siteLibelle]="field?.value?.libelle"></yo-site>
        }
      }
      @default {
        <ng-container *ngTemplateOutlet="tplTextboxEnhanced;context:{field:field, form:form}"></ng-container>
      }
    }

  </div>

</ng-template>

<!--TEMPLATE TEXTAREA-->
<ng-template #tplTextarea let-field="field" let-form="form">

  <div [formGroup]="form">
    <ng-container *ngTemplateOutlet="tplTextareaEnhanced;context:{field:field, form:form}"></ng-container>
  </div>

</ng-template>

<!--TEMPLATE SELECT BUTTON-->
<ng-template #tplSelectButton let-field="field" let-form="form">

  <div [formGroup]="form">
    <p-selectButton [options]="field.options" [formControlName]="field.key"></p-selectButton>
  </div>

</ng-template>

<!--TEMPLATE EDITOR-->
<ng-template #tplPrimengEditor let-field="field" let-form="form">

  <div [formGroup]="form">
    <ng-container *ngTemplateOutlet="tplPrimengEditorEnhanced;context:{field:field, form:form}"></ng-container>
  </div>

</ng-template>


<!--TEMPLATE FILE-->
<ng-template #tplFile let-field="field" let-form="form">

  <div [formGroup]="form">

    <div class="row">
      <div class="col-md-12">
        <input type="file" [style.max-width.px]="field.width"
               [id]="field.key"
               (change)="onFileChange($event,field)"
               accept="image/jpeg, image/png"
               [readonly]="field.readonly">
      </div>
    </div>
    <div class="row mg-t-10">
      @if (!utils.isNullOrEmpty(previewFile)) {
        <div class="col-md-auto">
          <p class="font-12 genlabel">Prévisualisation avant enregistrement</p>
          <img id="previewImage" src="#" height="64">
        </div>
      }

      <div class="col">
        @if (!utils.isNullOrEmpty(previewFile)) {
          <p class="font-12 genlabel">Image enregistrée</p>
        }
        <yo-img-entity class="mg-r-5"
                       (onError)="docError=$event"
                       [displayNoImage]="true"
                       [ordre]="field.ordre"
                       [entityName]="field.entityName"
                       [height]="64"
                       [openable]="true"
                       [refresh]="field.refresh"
                       format="thumb"
                       [entityId]="getEntityId()"
                       [title]="getTitle()"></yo-img-entity>

        <!--n'afficher le bouton de suppression que pour les images qui existent réellement-->
        @if (!docError) {
          <i style="vertical-align: top;" class="fas fa-times mg-r-20 danger-color cursor"
             (click)="deleteFile(field)" title="Enlever la {{field.label}}" ></i>
        }

      </div>
    </div>
  </div>

</ng-template>


<!--TEMPLATE TEXTBOX AVEC PREFIX ET SUFFIX-->
<ng-template #tplTextboxEnhanced let-field="field" let-form="form">

  <div [formGroup]="form">

    @if (field.prefix && !field.suffix) {
      <div class="input-group input-group-sm ">
        @if (field.type!='hidden') {
          <div class="input-group-prepend ">
            <span class="input-group-text" [innerHTML]="dsSvc.bypassSecurityTrustHtml(field.prefix)"></span>
          </div>
        }
        <input [type]="field.type" [style.max-width.px]="field.width" class="form-control form-control-sm "
               [id]="field.key"
               (change)="changeInput($event)"
               [formControlName]="field.key" [readonly]="field.readonly">
        @if (field.type!='hidden') {
          <div class="input-group-append ">
            <ng-container *ngTemplateOutlet="tplIsFieldOk;context:{field:field,form:form}"></ng-container>
          </div>
        }
      </div>
    }

    @if (!field.prefix && field.suffix) {
      <div class="input-group input-group-sm ">
        <input [type]="field.type" [style.max-width.px]="field.width" class="form-control form-control-sm "
               [id]="field.key"
               (change)="changeInput($event)"
               [formControlName]="field.key" [readonly]="field.readonly">
        @if (field.type!='hidden') {
          <div class="input-group-append ">
            <span class="input-group-text" [innerHTML]="dsSvc.bypassSecurityTrustHtml(field.suffix)"></span>
            <ng-container *ngTemplateOutlet="tplIsFieldOk;context:{field:field,form:form}"></ng-container>
          </div>
        }
      </div>
    }

    @if (field.suffix && field.prefix) {
      <div class="input-group input-group-sm ">
        @if (field.type!='hidden') {
          <div class="input-group-prepend ">
            <span class="input-group-text" [innerHTML]="dsSvc.bypassSecurityTrustHtml(field.prefix)"></span>
          </div>
        }
        <input [type]="field.type" [style.max-width.px]="field.width" class="form-control form-control-sm "
               [id]="field.key"
               (change)="changeInput($event)"
               [formControlName]="field.key" [readonly]="field.readonly">
        @if (field.type!='hidden') {
          <div class="input-group-append ">
            <span class="input-group-text" [innerHTML]="dsSvc.bypassSecurityTrustHtml(field.suffix)"></span>
            <ng-container *ngTemplateOutlet="tplIsFieldOk;context:{field:field,form:form}"></ng-container>
          </div>
        }
      </div>
    }

    @if (!field.suffix && !field.prefix) {
      <div class="input-group input-group-sm ">
        <input [type]="field.type" [style.max-width.px]="field.width" class="form-control form-control-sm"
               [id]="field.key"
               (change)="changeInput($event)"
               [formControlName]="field.key" [readonly]="field.readonly">
        @if (field.type!='hidden') {
          <div class="input-group-append ">
            <ng-container *ngTemplateOutlet="tplIsFieldOk;context:{field:field,form:form}"></ng-container>
          </div>
        }
      </div>
    }

  </div>
</ng-template>

<!--TEMPLATE TEXTAREA-->
<ng-template #tplTextareaEnhanced let-field="field" let-form="form">
  <div [formGroup]="form">
    <div class="input-group input-group-sm ">
      <textarea

        [style.max-width.px]="field.width" class="form-control form-control-sm"
        [id]="field.key"
        [formControlName]="field.key" [readonly]="field.readonly"
        rows="4"
      >
      </textarea>
      <div class="input-group-append ">
        <ng-container *ngTemplateOutlet="tplIsFieldOk;context:{field:field,form:form}"></ng-container>
      </div>
    </div>

  </div>
</ng-template>

<!-- TEMPLATE COLOR -->
<ng-template #tplColor let-field="field" let-form="form">
  <!--<pre>{{field.options | json}}</pre>-->
  <div [formGroup]="form">
    <p-dropdown
      filter="true"
      [formControlName]="field.key"
      appendTo="body"
      placeholder="sélection..."
      optionLabel="{{field.optionLabel}}"
      [options]="field.options"
      [disabled]="field.readonly">
      <ng-template let-couleur pTemplate="selectedItem">
        <yo-couleur [hexColor]="couleur.hexa" class="mg-r-5"
                    style="width:16px;vertical-align:middle"></yo-couleur>
        <span style="vertical-align:middle; margin-left: .5em">{{couleur.libelle}}</span>
      </ng-template>
      <ng-template let-couleur pTemplate="item">
        <div style="position: relative;height: 25px;">
          <yo-couleur [hexColor]="couleur.hexa" class="mg-r-5"
                      style="width:24px;position:absolute;top:1px;left:5px"></yo-couleur>
          <div style="font-size:14px;margin-top:4px;margin-left:30px;">{{couleur.libelle}}</div>
        </div>
      </ng-template>
    </p-dropdown>

  </div>
</ng-template>

<!--TEMPLATE PRIMENG RICH TEXT EDITOR-->
<ng-template #tplPrimengEditorEnhanced let-field="field" let-form="form">
  <div [formGroup]="form">

    <div>
      <p-editor

        [style.max-width.px]="field.width" class="autoscroll"
        [id]="field.key"
        [formControlName]="field.key" [readonly]="field.readonly"
        [style]="{'height':'100px'}">
        <ng-template pTemplate="header">
          <div class="p-dialog-title">
            <yo-primeng-editor-header></yo-primeng-editor-header>
          </div>
        </ng-template>
      </p-editor>

    </div>

  </div>
</ng-template>

<!--CHAMP EST OK-->
<ng-template #tplIsFieldOk let-form="form" let-field="field">

  @if (field.type!='hidden' && form.controls[field.key].dirty && form.controls[field.key].invalid) {
    <label class="input-group-text icon-validation" [for]="field.key"
           [title]="field.label+' n\'est pas correctement renseigné'">
      <i class="fa fa-times danger-color "></i>
    </label>
  }

</ng-template>
